import { connect } from 'react-redux';
import View from './Select';
import { getSSPData } from '../../../../screens/ChargerDetails/selectors';
import dictionariesTypesEnum from '../../../constants/dictionaries';

const mapStateToProps = (state, { options }) => ({
  options: options || getSSPData(state, dictionariesTypesEnum.telemetryMetrics, [])
    .filter((metric) => metric && metric.status === 'ACTIVE')
    .map((metric) => ({ value: metric.code, label: metric.title }))
    .sort((prev, next) => prev.label.localeCompare(next.label)),
});

const mapDispatchToProps = () => ({});

const FilterMetricsSelector = connect(mapStateToProps, mapDispatchToProps)(View);

export default FilterMetricsSelector;
